import { createContext, useContext } from 'react';
import type { MarketplaceAccess } from './types';

export const EntitlementContext = createContext<MarketplaceAccess | null>(null);

/** Active entitlement; null outside `<EntitlementGuard>` (e.g. /login). */
export function useEntitlementContext(): MarketplaceAccess | null {
  return useContext(EntitlementContext);
}
